export const mobilityMonthlyCharge = 'totalMobilityMonthlyCharge';
export const mobilityOneTimeCharge = 'mobilityOneTimeCharge';
export const optionMobility = 'Mobility';

export const pricingFields = [mobilityMonthlyCharge, mobilityOneTimeCharge];
